import { v1_2_get_booking_trip } from "./v1_2_get_booking_trip";
import { v1_2_get_booking_passenger } from "././v1_2_get_booking_passenger";
//import { v1_2_get_booking_note } from "./v1_2_get_booking_note";
import { v1_2_get_booking_payment } from "./v1_2_get_booking_payment";
import { v1_2_get_booking_payment_transaction } from "./v1_2_get_booking_payment_transaction";
//import { v1_2_get_booking_document } from "./v1_2_get_booking_document";
//import { v1_2_get_booking_communication } from "./v1_2_get_booking_communication";

export class v1_2_get_booking {
    group_booking_id: number | null = null;
    your_reference: string | null = null;
    session_id: string | null = null;
    booking_error: string | null = null;
    trips: v1_2_get_booking_trip[] = [];
    passengers: v1_2_get_booking_passenger[] = [];
    //notes: v1_2_get_booking_note[] = [];
    payments: v1_2_get_booking_payment[] = [];
    payment_transactions: v1_2_get_booking_payment_transaction[] = [];
    //documents: v1_2_get_booking_document[] = [];
    //communications: v1_2_get_booking_communication[] = [];
}